import { RouterConfig, routerConfigToRouteKey } from '@scorenco/core';

import config from './router-config';

export const routerConfig: RouterConfig = config;

export const RouteKey = routerConfigToRouteKey(routerConfig);
